import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { EditIcon } from "lucide-react";
import MembersForm from "@/v2/components/pages/members/Form";

export default function EditMember({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button
                    size={"sm"}
                    variant={"outline"}
                    className="flex items-center gap-2"
                >
                    <EditIcon className="h-4 w-4" />
                    {isInside && "Edit"}
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Edit User Details
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        Fill in the details to edit user{" "}
                    </DialogDescription>
                </DialogHeader>
                <MembersForm id={id} closeOnSave={() => setOpen(false)} />
            </DialogContent>
        </Dialog>
    );
}
